import { autoWebViewJs } from "../../AutoWebViewJs"


function hasPermission(){
    let script = `var bl = com.fanfanlo.lib.permissions.FloatPermission.hasPermission();\n bl;`
    let res = autoWebViewJs.callScript<boolean>(script);
    return res.javaResultData as boolean
}

function openPermission(){
    let script = `var bl = com.fanfanlo.lib.permissions.FloatPermission.openPermission();\n bl;`
    let res = autoWebViewJs.callScript<boolean>(script);
    return res.javaResultData as boolean
}

export const floatingInfo = {
    hasPermission,
    openPermission
}
